import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/VacancyGroup/vacancyGroup.container"
    ).then((module) => ({
        default: module.VacancyGroup
    }))
);
